import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface StatRowProps {
  children: ReactNode;
  className?: string;
}

export function StatRow({ children, className }: StatRowProps) {
  return (
    <div
      className={cn(
        // Mobile: horizontal scroll with snap
        'flex gap-2 overflow-x-auto snap-x snap-mandatory -mx-[var(--page-padding-x)] px-[var(--page-padding-x)] pb-2',
        'scrollbar-none',
        // Desktop: grid, no scroll
        'md:grid md:grid-cols-4 md:overflow-visible md:mx-0 md:px-0 md:pb-0',
        className,
      )}
    >
      {children}
    </div>
  );
}
